import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import DefaultLayout from "../layouts/DefaultLayout.vue";
import BlankLayout from "../layouts/BlankLayout.vue";
import { ElMessage } from "element-plus";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: DefaultLayout, // 使用包含头尾的布局
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "Home",
        component: () => import("../views/Home.vue"),
      },
      {
        path: "products",
        name: "Products",
        component: () => import("../views/Products.vue"),
      },
      {
        path: "about",
        name: "About",
        component: () => import("../views/About.vue"),
      }
    ],
  },
  {
    path: "/login",
    component: BlankLayout, // 使用空白布局（无头尾）
    children: [
      {
        path: "",
        name: "Login",
        component: () => import("../views/Login.vue"),
      },
      {
        path: "/ysxy",
        name: "Ysxy",
        component: () => import("../views/ysxy.vue"),
      },
      {
        path: "/syxy",
        name: "Syxy",
        component: () => import("../views/syxy.vue"),
      },
      {
        path: "/termsOfService",
        name: "termsOfService",
        component: () => import("../views/termsOfService.vue"),
      },
      {
        path: "/privacyPolicy",
        name: "privacyPolicy",
        component: () => import("../views/privacyPolicy.vue"),
      },
      {
        path: "/order",
        name: "Order",
        component: () => import("../views/Order.vue"),
        meta: {
          requiresAuth: true, // 标记该路由需要登录才能访问
        },
      },
      {
        path: "/orderDetail/:orderId",
        name: "OrderDetail",
        component: () => import("../views/OrderDetail.vue"),
        meta: {
          requiresAuth: true, // 标记该路由需要登录才能访问
        },
      },
      {
        path: "/appDownload",
        name: "appDownload",
        component: () => import("../views/appDownload.vue"),
        meta: {
          requiresAuth: false, // 标记该路由不需要登录才能访问
        },
      },
        {
        path: "paymentMethod",
        name: "paymentMethod",
        component: () => import("../views/paymentMethod.vue"),
      },
       {
        path: "payPage",
        name: "payPage",
        component: () => import("../views/payPage.vue"),
      },
      {
        path: "payNow",
        name: "payNow",
        component: () => import("../views/payNow.vue"),
      },
      {
        path: "paymentSuccessful",
        name: "paymentSuccessful",
        component: () => import("../views/paymentSuccessful.vue"),
      },
       {
        path: "lklPay",
        name: "lklPay",
        component: () => import("../views/lklPay.vue"),
      }
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 配置全局前置守卫
router.beforeEach((to: any, from: any, next: any) => {
  // 获取 token
  const token = localStorage.getItem("token");

  //  判断目标路由是否需要登录 (通过 meta 字段判断)
  if (to.meta.requiresAuth) {
    // 如果需要登录，且没有 token，则强制跳转到登录页
    if (!token) {
      ElMessage.error("请登录!");
      next("/login");
    } else {
      // 有 token
      next();
    }
  } else {
    // 其他页面方形
    next();
  }
});

export default router;
